import { getCommercialBusinessLabel } from './getCommercialBusinessLabel';
import { getCommercialCoworkingTitle } from './getCommercialCoworkingTitle';
import { IOffer } from '../../../types/offer';

interface ITypeMatcher {
  name: string;
  getTitle(): string;
}

const matcher = (name: string, getTitle: () => string): ITypeMatcher => ({ name, getTitle });

export function getCommercialTypeTitle(offer: IOffer): string {
  const matchers: ITypeMatcher[] = [
    matcher('office', () => getCommercialCoworkingTitle(offer, 'Офис')),
    matcher('shoppingArea', () => 'Торговая площадь'),
    matcher('warehouse', () => 'Склад'),
    matcher('freeAppointmentObject', () => 'Свободного назначения'),
    matcher('industry', () => 'Помещение под производство'),
    matcher('publicCatering', () => 'Общепит'),
    matcher('manufacture', () => 'Производство'),
    matcher('autoService', () => 'Автосервис'),
    matcher('business', () => getCommercialBusinessLabel(offer)),
    matcher('building', () => 'Здание'),
    matcher('domesticServices', () => 'Бытовые услуги'),
    matcher('commercialLand', () => 'Коммерческая земля'),
  ];

  return matchers.reduce<string>((acc, item) => {
    if (offer.category === `${item.name}Rent` || offer.category === `${item.name}Sale`) {
      return item.getTitle();
    }

    return acc;
  }, '');
}
